import { render, staticRenderFns } from "./BannerRight.vue?vue&type=template&id=01664804&scoped=true&"
import script from "./BannerRight.vue?vue&type=script&lang=js&"
export * from "./BannerRight.vue?vue&type=script&lang=js&"
import style0 from "./BannerRight.vue?vue&type=style&index=0&id=01664804&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01664804",
  null
  
)

export default component.exports